// Auto-generated by scripts/generate-version.mjs — do not edit.
export const VERSION = "0.2.4";

export interface GeoboxGlVersionInfo {
  name: string;
  version: string;
  buildTime: string;
  gitCommit: string;
}

export const VERSION_INFO: GeoboxGlVersionInfo = {
  "name": "@geobox/geobox-gl-js",
  "version": "0.2.4",
  "buildTime": "2026-10-28T07:44:27.196Z",
  "gitCommit": "fbc51ce"
};
